// extracted by mini-css-extract-plugin
export var button = "ButtonLink-module--button--Q8QuJ";
export var text = "ButtonLink-module--text--1AKu7";